import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { nullSafe } from 'Utility/globalMethods';
import { portalModalSelector, getBackofficeUser } from 'Store/selectors';
import { goPopup } from 'Store/actions/portalModalActions';
import * as actionLayer from '../../modules/UsersActions';
import DeleteUserPopup from './DeleteUserPopup';

const mapDispatchToProps = (dispatch) => ({
	deleteUser: (payload) =>
		dispatch(
			actionLayer.backofficeUserDelete.request({
				...payload
			})
		),
	closeModal: () => dispatch(goPopup('')),
	...bindActionCreators(actionLayer, dispatch),
});

const mapStateToProps = (state) => ({
	isLoading: nullSafe(() => getBackofficeUser(state, 'isLoading'), false),
	payload: nullSafe(() => portalModalSelector(state).data.payload, false),
});

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps) => ({
	...stateProps,
	actions: dispatchProps,
}))(DeleteUserPopup);
